import { Tooltip, breakpoints, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { Info } from '@phosphor-icons/react';
import { resetButtonStyles } from '../../utils/styles';
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const infoIconButtonStyles = css`
  border: 2px solid transparent;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  margin-inline-start: 0.375rem;
  margin-top: -5px;

  &:focus-visible {
    border: 2px solid ${vars.colors.focusRing};
    transition: all 0.2s ease;
  }

  @media (min-width: ${breakpoints._768}) {
    cursor: default;
    margin-top: -3px;
  }
`;
const SummaryPriceInformation = _ref => {
  let {
    id,
    markup,
    price
  } = _ref;
  const {
    t
  } = useTranslation();
  const markupLabel = t('SeatMap.PriceInformation.Markup');
  const priceLabel = t('SeatMap.PriceInformation.Price');
  const providerCostLabel = t('SeatMap.PriceInformation.ProviderCost');
  const priceInfoTotalLabel = t('SeatMap.PriceInformation.TotalPrice');
  return /*#__PURE__*/_jsx("div", {
    "data-testid": `priceInfoTooltip-${id}`,
    children: /*#__PURE__*/_jsx(Tooltip, {
      content: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [markupLabel, ": ", priceUtils.formatPrice(markup)]
        }), /*#__PURE__*/_jsxs("div", {
          children: [providerCostLabel, ": ", priceUtils.formatPrice(price - markup)]
        }), /*#__PURE__*/_jsxs("div", {
          children: [priceInfoTotalLabel, ": ", priceUtils.formatPrice(price)]
        })]
      }),
      title: priceLabel,
      children: /*#__PURE__*/_jsx("button", {
        "aria-label": priceLabel,
        className: cx(resetButtonStyles, infoIconButtonStyles),
        type: "button",
        children: /*#__PURE__*/_jsx(Info, {
          color: vars.colors.signal.information.foreground,
          size: 20,
          weight: "fill"
        })
      })
    })
  });
};
export default SummaryPriceInformation;
//# sourceMappingURL=SummaryPriceInformation.js.map